/* Create the JavaScript file for handling animations */
// three-columns-component.js
document.addEventListener('DOMContentLoaded', function() {
  // Add hover effects and animations for three columns section
  const columnItems = document.querySelectorAll('.column-item');
  
  // Track when images are loaded
  function handleImageLoaded() {
    // When all images are loaded, make sure animations play smoothly
    columnItems.forEach((column, index) => {
      // Force a reflow to ensure animations are properly applied
      setTimeout(() => {
        const bg = column.querySelector('.column-bg');
        if (bg) {
          bg.style.animationPlayState = 'running';
        }
      }, 100);
    });
  }
  
  // Check if images are loaded
  window.addEventListener('load', handleImageLoaded);
  
  // Handle hover effects for wave animations
  columnItems.forEach(column => {
    column.addEventListener('mouseenter', function() {
      const waveEffects = this.querySelectorAll('.wave-effect');
      waveEffects.forEach(wave => {
        wave.style.animationPlayState = 'running';
        wave.style.opacity = parseFloat(wave.style.opacity || 0.1) * 2;
      });
    });
    
    column.addEventListener('mouseleave', function() {
      const waveEffects = this.querySelectorAll('.wave-effect');
      waveEffects.forEach(wave => {
        wave.style.animationPlayState = 'running';
        setTimeout(() => {
          wave.style.opacity = parseFloat(wave.style.opacity || 0.2) / 2;
        }, 200);
      });
    });
  });
});